import { css } from "styled-components";

const variables = css`
  :root {
    --burgundy: #4a1a2b;
    --burgundy-95: rgba(74, 26, 43, 0.95);
    --burgundy-85: rgba(74, 26, 43, 0.85);
    --burgundy-40: rgba(74, 26, 43, 0.4);

    --rose: rgba(240, 216, 221);
    --rose-90: rgba(240, 216, 221, 0.9);
    --rose-80: rgba(240, 216, 221, 0.8);
    --rose-70: rgba(240, 216, 221, 0.7);
    --rose-20: rgba(240, 216, 221, 0.2);

    --teal: #4e878c;
    --teal-90: rgba(78, 135, 140, 0.9);
    --teal-80: rgba(78, 135, 140, 0.8);
    --teal-40: rgba(78, 135, 140, 0.4);
    --teal-20: rgba(78, 135, 140, 0.2);

    --gray: #aaa;
    --dark-slate: #495670;
    --slate: #8892b0;
    --light-slate: #a8b2d1;
    --lightest-slate: #ccd6f6;

    --shadow-light: rgba(0, 0, 0, 0.1);
    --shadow-medium: rgba(0, 0, 0, 0.15);

    --dark-80: rgba(0, 0, 0, 0.8);
    --dark-50: rgba(0, 0, 0, 0.5);
    --dark-30: rgba(0, 0, 0, 0.3);

    --white-30: rgba(255, 255, 255, 0.3);
    --white-10: rgba(255, 255, 255, 0.1);
    --white-5: rgba(255, 255, 255, 0.05);

    // --font-sans: "Calibre", "Segoe UI", -apple-system, BlinkMacSystemFont,
    //   "Helvetica Neue", sans-serif;
    --font-sans: "Calibre", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;
    --fz-heading1: 80px;
    --fz-heading2: 50px;
    --fz-title: clamp(40px, 5vw, 60px);

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s,
      transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
